export class LocalStorageKeys{

    static readonly RecentEntities:string="recentEntities"
    static readonly NewBookmarks:string="newBookmarks"
    static readonly CheckSignerConfirmation="AVOID_SIGNER_CONFIRMATION"
    static readonly CheckResponsibleHelp="AVOID_RESPONSIBLE_HELP"
    static readonly ProcedureSearchView="procedureSearchView"
    static readonly NewRecentApps: string = "newRecentApps"
    static readonly HelpPreferences: string = "helpPreferences"
}
